export default __webpack_public_path__ + "static/media/laval6.11a76285.jpg";